import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getregistrationbymember } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";

function Myeventregistration() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("id") || "";
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selected, setSelected] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    const userdata=JSON.parse(localStorage.getItem('userData'))
    
    try {
      const response = await getregistrationbymember((userdata.email));
      
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try {
      console.log('data', data);
    } catch (error) {
      console.error("Error logging data:", error);
    }
  }, [data]);
  
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchInitialData();
  }, []);

  const handleEdit = (item) => {
    try {
      setSelected(item);
      window.location.href = `/viewregistration?id=${item.id}`;
      // Or use navigate(`/viewregistration?id=${item.id}`) if using React Router
    } catch (error) {
      console.error("Error navigating to viewregistration:", error);
    }
  };
  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                  <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                      <h4 className="card-title fw-semibold">Event Registrations</h4>
                       
                      </div>
                    </div>
                    
                    <div className="card-body">
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                     
                        {/* <a href='/events'>
                        <button
                          className="btn btn-info btn-sm me-2"
                          style={{ minWidth: 130 }}
                        >
                          New
                        </button>
                      </a> */}
                      </div>
                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                               columns={[
                                "id",
                                "name",
                                "phonenumber",
                                "email",
                                "startdate",
                                "enddate",
                                "package_name",
                                "adults",
                                "kids",
                                "rate",
                                "paymentstatus",
                                "orderid"
                              ]}
                              data={data}
                              
                            />
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Myeventregistration;
